export default "__VITE_ASSET__DMm2LKdj__"